import { render } from "./HeaderWaitingList.vue?vue&type=template&id=f0d238f6&scoped=true"
import script from "./HeaderWaitingList.vue?vue&type=script&lang=js"
export * from "./HeaderWaitingList.vue?vue&type=script&lang=js"

import "./HeaderWaitingList.vue?vue&type=style&index=0&id=f0d238f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d238f6"]])

export default __exports__